import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';
import Dotdotdot from 'react-dotdotdot';
import { BRANDING_LOGO_IMAGE, renderImage } from 'helpers/ImageHelper';
import { noop } from 'helpers/GlobalHelper';
import { helperGetRelativeUrl } from 'helpers/RouteHelper';
import AltHeaderComponent from 'components/AltHeader';
import Icon from 'components/Icon';
import { getNetworkLogoUrl, LINK_REL } from 'helpers/ContentHelper';
import { getAnonymousTuneIn, getCTAUrl } from '../../SeriesDetailHelpers';
import altHeaderStyle from '../../styles/AltHeader.css';
import Style from './Branding.module.scss';

class Branding extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { previewButtonClick, hasTrailer } = this.props;
    const { autoPlayPreviewParam } = window.ExternalConfig;

    if (window.location.search.includes(autoPlayPreviewParam) && hasTrailer) {
      previewButtonClick();
    }
  }

  seoHeaderWrapper(headline) {
    const { titleClampSize, headlineIsPrimary } = this.props;
    return (
      headlineIsPrimary && (
        <Dotdotdot clamp={titleClampSize} className={Style.title}>
          {headline}
        </Dotdotdot>
      )
    );
  }

  renderCTA = ({ votingCTA, containerClassName }) => {
    if (!votingCTA) return null;
    const { ctaText, url, target } = votingCTA;

    const targetUrl = target || '_blank';
    const rel = target ? '' : LINK_REL;
    const ctaUrl = getCTAUrl(url);

    return (
      ctaText &&
      ctaUrl &&
      targetUrl && (
        <div className={classNames([Style.ctaButtonContainer, containerClassName])}>
          <Link href={ctaUrl} target={targetUrl} className={Style.ctaButton} rel={rel}>
            <p className={Style.ctaButtonText}>{ctaText}</p>
          </Link>
        </div>
      )
    );
  };

  render() {
    const {
      breakpoint,
      renderBackground,
      className,
      containerClassName,
      name,
      tuneIn,
      network,
      showLogo,
      isHeader,
      stickyHeaderCallback,
      children,
      showActionButtons,
      favoriteButton,
      screenUrl,
      renderAltHeader,
      votingCTA,
      isPersonality,
      onClick,
      isAnonymous,
      item,
      hasTrailer,
      previewButtonClick,
    } = this.props;

    const { seriesDetailAnonymous_previewButton: anonymousPreviewButton } = window.Language;
    const { description, seriesType } = item;
    const anonymousTuneIn = getAnonymousTuneIn(seriesType);
    const hasNetworkLogo = !!window.ExternalConfig.networkLogo;
    const networkLogoUrl = hasNetworkLogo ? getNetworkLogoUrl(network) : null;
    const headerClasses = classNames(Style.header, isAnonymous ? Style.anonymous : null);
    const url = helperGetRelativeUrl({ url: screenUrl });
    const imageLogo = renderImage({
      alt: name,
      breakpoint,
      className: Style.titleImage,
      imageType: BRANDING_LOGO_IMAGE,
      src: showLogo,
    });

    const titleElement = showLogo ? imageLogo : name;

    const tuneInElement = !isPersonality && hasNetworkLogo && (
      <span className={Style.meta}>
        <img src={networkLogoUrl} alt={network} />
        <span>{tuneIn}</span>
      </span>
    );

    const altTuneInElement = children || <span className={Style.altMeta}>{tuneInElement}</span>;
    const anonymousTuneInElement = isAnonymous ? (
      <span className={Style.meta}>
        <span>{anonymousTuneIn}</span>
      </span>
    ) : null;

    const anonymousDescription =
      description && isAnonymous ? (
        <div className={Style.description}>
          <p>{description}</p>
        </div>
      ) : null;

    const actionButtons =
      !showActionButtons || isAnonymous ? null : (
        <div className={Style.actionButtons}>{favoriteButton}</div>
      );

    const previewButton =
      isAnonymous && hasTrailer ? (
        <div className={Style.preview}>
          <button onClick={previewButtonClick} className={Style.btn}>
            <Icon
              icon="play-button-thin"
              color="white"
              size="full"
              theme={Style}
              viewBox="1 1 36 36"
            />
            {anonymousPreviewButton}
          </button>
        </div>
      ) : null;

    const altHeader = !renderAltHeader ? (
      <div className={Style.altHeaderReplacement} />
    ) : (
      <AltHeaderComponent
        isHeader={isHeader}
        isAltHeader
        title={name}
        onTitleClick={() => {
          window.scrollTo(0, 0);
        }}
        stickyHeaderCallback={stickyHeaderCallback}
        theme={altHeaderStyle}
        className={Style.altHeader}
      >
        {altTuneInElement}
      </AltHeaderComponent>
    );

    return (
      <div className={headerClasses} onClick={onClick}>
        {altHeader}
        {isAnonymous && renderBackground()}
        <div className={classNames(Style.headerContainer, className, containerClassName)}>
          <Link to={url} className={Style.titleLink} data-testid="remove-child-style">
            {this.seoHeaderWrapper(titleElement)}
          </Link>
          <div className={Style.tuneInContainer}>
            {tuneInElement}
            {anonymousTuneInElement}
            {actionButtons}
          </div>
          {anonymousDescription}
          {previewButton}
        </div>
        {this.renderCTA({ votingCTA, containerClassName })}
      </div>
    );
  }
}

Branding.defaultProps = {
  breakpoint: null,
  children: null,
  className: null,
  containerClassName: null,
  favoriteButton: {},
  hasTrailer: false,
  headlineIsPrimary: true,
  isAnonymous: false,
  isHeader: null,
  isPersonality: false,
  item: null,
  name: null,
  network: null,
  onClick: () => {},
  previewButtonClick: noop,
  renderAltHeader: true,
  renderBackground: noop,
  screenUrl: null,
  showLogo: null,
  titleClampSize: 0,
  tuneIn: null,
  votingCTA: {},
};

Branding.propTypes = {
  breakpoint: PropTypes.string,
  children: PropTypes.shape({}),
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  favoriteButton: PropTypes.shape({}),
  hasTrailer: PropTypes.bool,
  headlineIsPrimary: PropTypes.bool,
  isAnonymous: PropTypes.bool,
  isHeader: PropTypes.bool,
  isPersonality: PropTypes.bool,
  item: PropTypes.shape({}),
  name: PropTypes.string,
  network: PropTypes.string,
  onClick: PropTypes.func,
  previewButtonClick: PropTypes.func,
  renderAltHeader: PropTypes.bool,
  renderBackground: PropTypes.func,
  screenUrl: PropTypes.string,
  showActionButtons: PropTypes.bool.isRequired,
  showLogo: PropTypes.string,
  stickyHeaderCallback: PropTypes.func.isRequired,
  titleClampSize: PropTypes.number,
  tuneIn: PropTypes.string,
  votingCTA: PropTypes.shape({}),
};

export default Branding;
